const Pagination = (props: {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    canGoNext: boolean;
    canGoPrevious: boolean;
}) => {
    const { currentPage, totalPages, onPageChange, canGoNext, canGoPrevious } = props;

    const handlePageChange = (page: number) => {
        onPageChange(page);
    };

    if (totalPages <= 1) {
        return null;
    }

    const getPageNumbers = () => {
        const pages: Array<number> = [];
        const maxPagesToShow = 3;

        if (totalPages <= maxPagesToShow) {
            // Show all pages
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Show first page, current page vicinity, and last page
            const startPage = Math.max(1, currentPage - 1);
            const endPage = Math.min(totalPages, currentPage + 1);

            if (startPage > 1) {
                pages.push(1);
                if (startPage > 2) {
                    pages.push(-1); // Ellipsis marker
                }
            }

            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }

            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    pages.push(-1); // Ellipsis marker
                }
                pages.push(totalPages);
            }
        }

        return pages;
    };

    const pageNumbers = getPageNumbers();

    return (
        <nav aria-label="Pagination">
            <ul className="pagination pagination-sm justify-content-end mb-0">
                <li className={`page-item ${!canGoPrevious ? "disabled" : ""}`}>
                    <button
                        className="page-link"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={!canGoPrevious}
                        aria-label="Previous page"
                    >
                        <span className="fas fa-chevron-left"></span>
                    </button>
                </li>

                {pageNumbers.map((page, index) => {
                    if (page === -1) {
                        return (
                            <li key={`ellipsis-${index}`} className="page-item disabled">
                                <span className="page-link">...</span>
                            </li>
                        );
                    }

                    return (
                        <li key={page} className={`page-item ${page === currentPage ? "active" : ""}`}>
                            <button
                                className="page-link"
                                onClick={() => handlePageChange(page)}
                                aria-label={`Go to page ${page}`}
                                aria-current={page === currentPage ? "page" : undefined}
                            >
                                {page}
                            </button>
                        </li>
                    );
                })}

                <li className={`page-item ${!canGoNext ? "disabled" : ""}`}>
                    <button
                        className="page-link"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={!canGoNext}
                        aria-label="Next page"
                    >
                        <span className="fas fa-chevron-right"></span>
                    </button>
                </li>
            </ul>
        </nav>
    );
};

export { Pagination };
